import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { fetchWithError } from "src/react-query/fetchWithError";
import { queryKeys } from "src/react-query/queryKeys";
import { authSlice } from "src/store/auth/auth.slice";

// Public routes that don't require profile API calls
const PUBLIC_ROUTES = ['/active-transaction', '/check-transaction-status'];

export const useUser = () => {
  const { isAuthenticated, user } = useSelector(({ auth }) => auth);
  const dispatch = useDispatch();
  const location = useLocation();
  
  // Check if current route is a public route
  const isPublicRoute = PUBLIC_ROUTES.some(route => location.pathname.startsWith(route));
  
  return useQuery(queryKeys.user(), fetchWithError, {
    enabled: isAuthenticated && !user && !isPublicRoute,
    onSuccess: (data) => {
      dispatch(authSlice.actions.setUser(data?.data));
    },
  });
};
